import styled from "@emotion/styled";
import { DatePicker, Form, Select, } from "antd";

interface SelectPickerProps {
    width?: string;
    mode?:string
}
export const DailyRevenueWrapper = styled.div`
    height: 232px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const TitleArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`;

export const SubTitleArea = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    h5,
    span {
        color: #ffffff !important;
        margin-bottom: 0 !important;
    }
`;

export const FilterArea = styled.div`
    display: flex;
    margin-top: 10px;
    align-items: flex-start;
`;

export const TitleAreaAmount = styled.div<any>`
    display: flex;
    flex-direction: column;

    h3,
    span {
        color: #ffffff !important;
        margin-bottom: 0 !important;
    }

    @media screen and (max-width: 576px) {
        span {
            font-size: 16px !important;
            line-height: 1.2;
        }
    }
`;

export const SubTitleAreaAmount = styled.div`
&&.ant-typography {
    color: #ffffff;
    font-size: 16px !important
}
`;


export const TitleAreNumber = styled.div`
    display: flex;
    align-items: center;
    line-height: 1;

    img {
        margin-left: 5px;
    }

    @media screen and (max-width: 576px) {
        span {
            font-size: 30px !important;
            line-height: 0.9;
        }
    }
`;

export const RangePicker = styled(DatePicker.RangePicker)`
    height: 35px;
    float: "right";
    color: "#fffff !important";
    background: "rgba(255, 255, 255, 0.3)";

    .ant-picker-input > input {
        color: #ffffff !important;
    }

    &.ant-picker-focused {
        .ant-picker-separator {
            color: #ffffff;
        }
    }

    .ant-picker-separator,
    .ant-picker-suffix {
        color: #ffffff;
    }
`;

export const SelectPicker = styled(Form.Item) <SelectPickerProps>`
 && .ant-form-item-label > label {
    color: #ffffff;
    padding-left: 5px
  }
    height: 35px;
    width: ${props => props.width || '280px'};
    float: "right";
    color: 'rgba(55, 25, 25, 1)' !important;
    border: ${props => props.mode === 'light' ? '1px solid rgba(255, 255, 255, 1)' : 'none'};
    border-radius: 5px;
    background: rgba(255, 255, 255, 0.3);

    .ant-picker-input > input {
        color: #ffffff !important;
    }

    &.ant-picker-focused {
        .ant-picker-separator {
            color: #ffffff;
        }
    }

    .ant-picker-separator,
    .ant-picker-suffix {
        color: #ffffff;
    }
`;


export const SelectContainer = styled(Select)<any>`
float: right;
&&.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    width: 100%;
    padding: 0 11px;
    border:none;
    background: rgba(0,0,0,0)
    
  }
&&.ant-select .ant-select-arrow {
    color: #ffffff
}
&&.ant-select-single.ant-select-show-arrow .ant-select-selection-item{
    color: #ffffff
}
&&.ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder{
    color: #ffffff
}
&&.ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder{
    color: #ffffff
}
&&.ant-select.ant-select-in-form-item  {
    width: ${props => props.width || '170px'};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

&&.ant-select.ant-select-in-form-item {
    width: 170px;
}
&&:where(.css-dev-only-do-not-override-1iacbu2).ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    background-color: rgba(96, 103, 110, 1);
    border:none
}
`;